<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="所属组">
                <el-select v-model="formInline.groupId" clearable filterable placeholder="所属组" >
                    <el-option v-for="item in groupData"
                               :key="item.id"
                               :label="item.groupName"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机">
                <el-input v-model="formInline.distributorPhone" placeholder="手机"></el-input>
            </el-form-item>

            <el-form-item label="姓名">
                <el-input v-model="formInline.distributorName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formInline.status"  placeholder="状态" >
                    <el-option v-for="item in statusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="formInline.platformId"  placeholder="平台" >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" @click="handleAdd">新增</el-button>
            <el-button type="success" @click="getQiyeWeixinFollowUsers">同步企业微信推广人员</el-button>
            <el-button type="success" @click="getQiyeWeixinFollowUserContacts">批量同步企业微信外部客户</el-button>
            <el-button type="success" @click="pushMomPlan">推送妈妈计划邀请链接</el-button>
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="platformId" label="平台" :formatter="platformShow" width="100"></el-table-column>
            <el-table-column prop="distributorPhone" label="手机号"  width="120"></el-table-column>
            <el-table-column prop="distributorName" label="姓名" width="120"></el-table-column>
            <el-table-column prop="relationNickName" label="昵称" width="120"></el-table-column>
            <el-table-column prop="groupName"  label="组名称" ></el-table-column>
            <el-table-column prop="status"  label="是否可用" :formatter="statusShow"  ></el-table-column>

            <el-table-column prop="distributorRelationCode"  label="分享码"   width="120"></el-table-column>

<!--            <el-table-column prop="effectiveDays"  label="有效天数"  width="70"></el-table-column>-->
            <el-table-column prop="percentage" label="分成比例"    width="70"></el-table-column>
            <el-table-column prop="robbedable" label="允许抢单" :formatter="statusShow"   width="90"></el-table-column>

            <el-table-column prop="renewable" label="允许续期"   :formatter="statusShow" width="70"></el-table-column>
            <el-table-column prop="selfable" label="允许邀请自己"  :formatter="statusShow"  width="90"></el-table-column>

            <el-table-column prop="distributorable" label="允许分销员互相邀请" :formatter="statusShow"   width="90"></el-table-column>

            <el-table-column prop="customerCount" label="客户数"  >
                <template slot-scope="scope">
                    <!--<a href=""  @click.native="handleRelation(scope.row)" target="_blank">111</a>-->
                    <router-link :to="{name:'distributorRelation', query: {distributorId:scope.row.id}}">{{scope.row.customerCount}} </router-link>
                </template>
            </el-table-column>
            <el-table-column prop="saleAmount" label="销售金额"   >
                <template slot-scope="scope">
                    <router-link :to="{name:'distributionOrder', query: {distributorId:scope.row.id}}">{{scope.row.saleAmount}} </router-link>
                    <!--<el-tag :click="handleOrder(scope.row)">123</el-tag>-->
                    <!--<a href="javascript:void(0);"  @click.native="handleOrder(scope.row)" target="_blank">{{saleAmount}}</a>-->
                </template>
            </el-table-column>
            <el-table-column prop="createTime"  label="创建时间" sortable></el-table-column>


            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="平台" required="true">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名" required="true">
                    <el-input type="text" v-model=form.distributorName clearable  placeholder="姓名" maxlength="40"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="手机号" required="true">
                    <el-input type="text" v-model=form.distributorPhone clearable  placeholder="手机号" maxlength="11"
                              show-word-limit></el-input>
                </el-form-item>


                <el-form-item label="关联微信用户" required="true" >
                    <el-input type="text" v-model=form.relationUserId clearable :disabled="form.id!=null"  placeholder="关联微信用户,关联后不可修改" maxlength="50"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="微信昵称" >
                    <el-input type="text" v-model=form.relationNickName clearable disabled="true"  placeholder="保存后显示" maxlength="50"
                              show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="分享码" >
                    <el-input type="text" v-model=form.distributorRelationCode clearable disabled="true"  placeholder="分享码自动生成" maxlength="20"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="所属组" required="true">
                    <el-select v-model="form.groupId"  placeholder="所属组" >
                        <el-option v-for="item in groupData"
                                   :key="item.id"
                                   :label="item.groupName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否可用">
                    <el-select v-model="form.status"  placeholder="是否可用" >
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item label="有效天数" >-->
<!--                    <el-input-number v-model="form.effectiveDays"  :min="1" :max="100000" label="有效天数"></el-input-number>-->
<!--                </el-form-item>-->

                <el-form-item label="分成比例" >
                    <el-input-number v-model="form.percentage" :precision="2" :step="0.05" :min="0.01" :max="1" label="分成比例"></el-input-number>
                </el-form-item>
                <el-form-item label="允许抢单">
                    <el-select v-model="form.robbedable"  placeholder="允许抢单" >
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="允许续期">
                    <el-select v-model="form.renewable"  placeholder="允许续期" >
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="允许邀请自己">
                    <el-select v-model="form.selfable"  placeholder="允许邀请自己" >
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="允许分销员互相邀请">
                <el-select v-model="form.distributorable"  placeholder="允许分销员互相邀请" >
                    <el-option v-for="item in statusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getPlatformList,getDistributorPageList,saveDistributor,getDistributor,getDistributorGroupOption,getQiyeWeixinFollowUsers,getQiyeWeixinFollowUserContacts,sendInvitePageMsg} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                groupData:[],
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                loading:true,
                dialogFormVisible:false,
                form:{"id": null,
                    "distributorPhone": "",
                    "distributorName": "",
                    "groupId": null,
                    "groupName": "",
                    "status": 1,
                    "createTime": null,
                    "relationUserId": "",
                    "distributorRelationCode": "",
                    "effectiveDays": 365,
                    "robbedable": 1,
                    "percentage": 0.15,
                    "renewable": 1,
                    "selfable": 1,
                    "distributorable": 1,},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    groupId:5,
                    status:1,
                    platformId:1
                },
                platformDisabled:false,


            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
            getDistributorGroupOption().then((res) => {
                this.groupData=res.data.value;
            });
        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                getDistributorPageList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;

                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            // handleDel(row){
            //     if(confirm("确定删除分享:"+row.title+"吗？")) {
            //         deleteShare({id: row.id}).then((res) => {
            //             if (res.data.status == 200) {
            //                 this.$message({
            //                     showClose: true,
            //                     message: '成功',
            //                     type: 'success'
            //                 });
            //                 this.getList(this.currentPage, this.pageSize);
            //             } else {
            //                 this.$message({
            //                     showClose: true,
            //                     message: res.data.message,
            //                     type: 'error'
            //                 });
            //             }
            //
            //         })
            //     }
            //
            // },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form.id=null;
                this.form.distributorPhone="";
                this.form.distributorName="";
                this.form.groupId=null;
                this.form.groupName="";
                this.form.status=1;
                this.form.createTime=null;
                this.form.updateTime=null;
                this.form.operater="";
                this.form.platformId=1;
                this.form.relationUserId="";
                this.form.distributorRelationCode="";
                this.form.effectiveDays=365;
                this.form.robbedable=1;
                this.form.percentage=0.15;
                this.form.renewable=1;
                this.form.selfable=1;
                this.form.distributorable=1;
                this.form.relationNickName="";


                //this.handleEdit(d);
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getDistributor({id:data.id}).then((res) => {
                    //console.log(res.data);
                    if(res.data.value!=undefined) {
                        this.form = res.data.value;
                    }
                });
            },
            getQiyeWeixinFollowUsers(){
                getQiyeWeixinFollowUsers().then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            getQiyeWeixinFollowUserContacts(){
                getQiyeWeixinFollowUserContacts().then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },

            pushMomPlan(){
                this.$prompt('请输入活动绑定码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    sendInvitePageMsg({'bindcode':value}).then((res) => {
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    });
                }).catch(() => {
                });
            },

            save(data){
                console.log(data);
                if(data.status==1){
                    if(data.distributorPhone==""){
                        this.$message({
                            message:"请输入手机号",
                            type:'error'
                        });
                        return;
                    }
                    if(data.distributorName==""){
                        this.$message({
                            message:"请输入姓名",
                            type:'error'
                        });
                        return;
                    }
                    if(data.relationUserId===""){
                        this.$message({
                            message:"请输入关联微信用户",
                            type:'error'
                        });
                        return;
                    }
                    if(data.groupId===""){
                        this.$message({
                            message:"请选择分组",
                            type:'error'
                        });
                        return;
                    }
                }

                // if(data.defaultConfig==""){
                //     this.$message({
                //         message:"请选择是否默认",
                //         type:'error'
                //     });
                //     return;
                // }
                saveDistributor(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },

            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;

            },
            platformShow(row,column,cellValue){
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
            }


        },
        handleRelation(row) {
            this.$router.push({path:'/distributorRelation',query:{distributorId:row.distributorId}})
        },
        handleOrder(row) {
            this.$router.push({path:'/distributionOrder',query:{distributorId:row.distributorId}})
        },
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/distributor.vue